import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Alerts } from '../models';
import { MessageService } from '@shared';

@Injectable({
  providedIn: 'root',
})
export class AlertsService {
  private apiUrl: string = environment.apiUrl + '/alerts';

  constructor(private httpClient: HttpClient) {}

  getAlerts() {
    return this.httpClient.get<Alerts>(`${this.apiUrl}`);
  }

  acknowledgeLtoAlert() {
    return this.httpClient.post(
      `${this.apiUrl}/acknowledge?type=New Item`,
      {},
    );
  }

  // Dismisses the failures the user has just reviewed. It is stored for the whole reporting
  // unit, like the LTO acknowledgement, so a sync that fails later still raises the alert.
  acknowledgeSyncFailureAlert() {
    return this.httpClient.post(
      `${this.apiUrl}/acknowledge?type=Sync Failure`,
      {},
    );
  }

  // Terms of service acceptance is stored per user, so the dialog never comes back
  // for someone who chose not to be reminded again, on any machine.
  hasAcceptedTerms() {
    return this.httpClient.get<boolean>(`${this.apiUrl}/terms`);
  }

  acceptTerms() {
    return this.httpClient.post(`${this.apiUrl}/terms`, {});
  }


}
